/* eslint-disable react/jsx-no-target-blank */
import { Box, Flex, Link as ChakraLink } from "@chakra-ui/react";
import { Link } from "react-router-dom";

interface propTypes {
  title: string;
  data: string;
  link: string;
}

function LandingSectionCard({ title, data, link }: propTypes) {
  return (
    <Flex
      direction="column"
      flex="1"
      fontFamily="'IBM Plex Mono', monospace"
      borderRadius="sm"
      p="6"
      gap={1}
      bg="rgba(255, 255, 255, 1)"
    >
      <Box fontSize={["sm"]} textTransform="capitalize" fontWeight="semibold">
        {title}
      </Box>
      <Box fontSize={["x-small"]} lineHeight="1.25rem">
        {data}
      </Box>
      <Box>
        <ChakraLink
          fontSize={["xs"]}
          textDecoration="underline"
          fontWeight="medium"
        >
          <a href={link} target="_blank">
            Learn more
          </a>
        </ChakraLink>
      </Box>
    </Flex>
  );
}

export default LandingSectionCard;
